import PageLayout, { type PageLayoutProps } from './PageLayout';

export default PageLayout;
export type { PageLayoutProps };
